"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarsFilter, faMagnifyingGlass, faCheck } from "@instadeepai/fontawesome-pro-regular";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
} from "@shared/ui";
import { Button, Input } from "@shared/ui";

interface ModulesHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  allTags: string[];
  selectedTags: string[];
  handleTagChange: (tag: string) => void;
}

export const ModulesHeader = ({
  searchQuery,
  setSearchQuery,
  allTags,
  selectedTags,
  handleTagChange,
}: ModulesHeaderProps) => {
  return (
    <div className="flex flex-col gap-8 pb-1">
      <div className="flex justify-between items-center">
        <h1 className="font-semibold text-[30px] text-gray-900 leading-[38px]">
          Modules
        </h1>
        <div className="flex items-center gap-4">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button 
                leftIcon={<FontAwesomeIcon icon={faBarsFilter} />} 
                variant="secondary" 
                size="sm" 
                className="rounded h-11 text-[#344054]"
              >
                Filters
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="start">
              <DropdownMenuLabel>Filter by Tag</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {allTags.map(tag => (
                <DropdownMenuCheckboxItem
                  key={tag}
                  checked={selectedTags.includes(tag)}
                  onSelect={(e) => e.preventDefault()}
                  onCheckedChange={() => handleTagChange(tag)}
                  icon={<FontAwesomeIcon icon={faCheck} />}
                >
                  {tag}
                </DropdownMenuCheckboxItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          <Input
            placeholder="Search"
            leftIcon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
            className="min-w-80 h-11"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
      <div className="space-y-1">
        <h2 className="font-semibold text-[#101828] text-[18px]">Available Modules</h2>
        <p className="text-[#475467] text-sm">Manage and forge new workflows with available modules.</p>
      </div>
    </div>
  );
}; 